import { SUPERANNUATION } from '@/core/field-names';

/**
 * Filtering fields that will only contribute to superannuation
 * document completion.
 * @param fieldValueMap {Object}
 * @param fieldValueMap.value {Any}
 * @param fieldValueMap.required {Boolean}
 * @param fieldValueMap.errorList {String[]}
 * @returns {String[]}
 */
export function filterSuperFieldsToBeIncluded(fieldValueMap) {
  const isEligibleForSuper =
    fieldValueMap[SUPERANNUATION.OPTION]?.value === 'Yes';

  const isEmployeeOrEmployerNominated =
    isEligibleForSuper &&
    (fieldValueMap[SUPERANNUATION.TYPE]?.value === 'employerNominated' ||
      fieldValueMap[SUPERANNUATION.TYPE]?.value === 'employeeNominated');

  const isEmployeeNominated =
    fieldValueMap[SUPERANNUATION.OPTION]?.value === 'Yes' &&
    fieldValueMap[SUPERANNUATION.TYPE]?.value === 'employeeNominated';

  const isEligibleForSuperAndNotSelfManaged =
    fieldValueMap[SUPERANNUATION.OPTION]?.value === 'Yes' &&
    fieldValueMap[SUPERANNUATION.TYPE]?.value !== 'selfManaged';

  const superannuationRule = {
    [SUPERANNUATION.OPTION]: true,
    [SUPERANNUATION.TYPE]: isEligibleForSuper,
    [SUPERANNUATION.NAME]: isEmployeeOrEmployerNominated,
    [SUPERANNUATION.TFN]: isEmployeeOrEmployerNominated,
    [SUPERANNUATION.FUND_NAME]: isEmployeeOrEmployerNominated,
    [SUPERANNUATION.MEMBER_NUMBER]: isEmployeeNominated,
    [SUPERANNUATION.DECLARATION]: isEligibleForSuperAndNotSelfManaged,
  };

  return Object.keys(superannuationRule).filter((key) => {
    return fieldValueMap[key]?.required && superannuationRule[key];
  });
}
export function filterSuperOptionalFieldsToBeIncluded(fieldValueMap) {
  const isEligibleForSuper =
    fieldValueMap[SUPERANNUATION.OPTION]?.value === 'Yes';

  const isSelfManagedSuperFund =
    isEligibleForSuper &&
    fieldValueMap[SUPERANNUATION.TYPE]?.value === 'selfManaged';

  const superannuationRule = {
    [SUPERANNUATION.SELF_MANAGED_FORM]: isSelfManagedSuperFund,
  };

  return Object.keys(superannuationRule).filter((key) => {
    return superannuationRule[key];
  });
}
